
import { createSlice } from '@reduxjs/toolkit';
import { fetcherPost, fetcherGet } from "../utils/fetcher";
import { APIS, isEmpty } from "../utils/constants";

const initialState = {
    isNestedstepCompleted: false,
    loader: false,
    selectedFlow: { isFlowSelected: false, flowtype: "" }
}

const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setNestedStep: (state, action) => {
            state.isNestedstepCompleted = action.payload;
        },
        setLoader: (state, action) => {
            state.loader = action.payload;
        },
        setFlow: (state, action) => {
            state.selectedFlow = action.payload;
        }
    }
});

export function updateStepper(payload) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.UPDATE_STEPPER, payload)
            .then(() => {
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getStudentFlow(callBack = false) {
    return (dispatch) => {
        // dispatch(setLoader(true));
        fetcherGet(APIS?.GET_B2C_FLOW)
            .then((res) => {
                const d = !isEmpty(res?.data) ? res?.data : { isFlowSelected: false, flowtype: "" };
                if (!isEmpty(d?.type)) {
                    dispatch(setFlow({ isFlowSelected: true, flowtype: d.type }));
                }
                if (callBack && typeof callBack === 'function') {
                    callBack({ isFlowSelected: true, flowtype: d.type });
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function setStudentFlow(payload, callback) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.SET_B2C_FLOW, payload)
            .then((res) => {
                dispatch(getStudentFlow());
                dispatch(setLoader(false));
                if(callback){
                    callback(res);
                }
            })
            .catch((err) => {
                if(callback){
                    callback(err);
                }
                dispatch(setLoader(false));
            });
    };
}

export const { setNestedStep, setLoader, setFlow } = commonSlice.actions;
export default commonSlice.reducer;